__turbopack_context__.v({
  "listItem": "QXACAW_listItem",
  "unorderedList": "QXACAW_unorderedList",
});
